import NoticeList from '@/controllers/notice/notice-list.js';

export default {
  extends: NoticeList,
}
